import { AnyAction } from 'redux';
import { put } from 'redux-saga/effects';

import * as actions from '@/store/actions';
import { apiClient } from '@/utils';
import { AxiosResponse } from 'axios';

export function* fetchStripeSettings(action: AnyAction) {
    try {
        const response: AxiosResponse = yield apiClient.get('/payment/stripe/v1/account');

        yield put(actions.FETCH_STRIPE_API_SETTINGS.success(response.data));
    } catch (error) {
        yield put(actions.FETCH_STRIPE_API_SETTINGS.failure(error));
    }
}

export function* editStripeSettings(action: AnyAction) {
    try {
        const response: AxiosResponse = yield apiClient.put('/payment/stripe/v1/account', action.payload);

        yield put(actions.EDIT_STRIPE_API_SETTINGS.success(response.data));
    } catch (error) {
        yield put(actions.EDIT_STRIPE_API_SETTINGS.failure(error));
    }
}
